// extracted by mini-css-extract-plugin
module.exports = {"title":"SearchResults_title__1M94O","noResultTitle":"SearchResults_noResultTitle__2IQ7p"};